(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2263],{

/***/ 89787:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[slug]",
      function () {
        return __webpack_require__(9689);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ LandingFeatureStorePage; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var shared_src = __webpack_require__(88805);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/how-it-works/how-it-works.module.css
var how_it_works_module = __webpack_require__(17682);
var how_it_works_module_default = /*#__PURE__*/__webpack_require__.n(how_it_works_module);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/icon-card/icon-card.module.css
var icon_card_module = __webpack_require__(65432);
var icon_card_module_default = /*#__PURE__*/__webpack_require__.n(icon_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/assets/search.tsx

const Search = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "search-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2847_1861)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.1385 22.3027C18.9258 24.1924 16.0545 25.3333 12.9167 25.3333C5.92106 25.3333 0.25 19.6623 0.25 12.6667C0.25 5.67106 5.92106 0 12.9167 0C19.9123 0 25.5833 5.67106 25.5833 12.6667C25.5833 15.8045 24.4424 18.6758 22.5527 20.8885L31.6238 29.9596C32.0143 30.3501 32.0143 30.9832 31.6238 31.3738C31.2332 31.7643 30.6001 31.7643 30.2096 31.3738L21.1385 22.3027ZM23.5833 12.6667C23.5833 18.5577 18.8077 23.3333 12.9167 23.3333C7.02563 23.3333 2.25 18.5577 2.25 12.6667C2.25 6.77563 7.02563 2 12.9167 2C18.8077 2 23.5833 6.77563 23.5833 12.6667Z",
                    fill: "url(#paint0_linear_2847_1861)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2847_1861",
                        x1: "0.25",
                        y1: "0",
                        x2: "31.9167",
                        y2: "31.6667",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2847_1861",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(0.25)"
                        })
                    })
                ]
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/assets/phone.tsx

const Phone = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "phone-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2847_1004)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.4167 0.333252C18.8644 0.333252 18.4167 0.780967 18.4167 1.33325C18.4167 1.88554 18.8644 2.33325 19.4167 2.33325C25.4918 2.33325 30.4167 7.25812 30.4167 13.3333C30.4167 13.8855 30.8644 14.3333 31.4167 14.3333C31.9689 14.3333 32.4167 13.8855 32.4167 13.3333C32.4167 6.15355 26.5964 0.333252 19.4167 0.333252Z",
                        fill: "url(#paint0_linear_2847_1004)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.6315 4.82621C12.5005 3.89284 12.0332 3.03896 11.3171 2.42402C10.601 1.80907 9.68488 1.47511 8.73991 1.48449H4.634C4.09466 1.48503 3.56133 1.59752 3.06795 1.81483C2.57458 2.03214 2.13197 2.3495 1.76829 2.74671C1.4046 3.14392 1.12781 3.61229 0.955532 4.122C0.78325 4.63172 0.719248 5.17162 0.7676 5.70735C1.23686 10.1134 2.7426 14.3467 5.16228 18.0628C7.3575 21.4992 10.2839 24.4118 13.7339 26.5942C17.4451 28.988 21.6667 30.482 26.0608 30.9565C26.601 31.0084 27.1461 30.9468 27.661 30.7759C28.1759 30.6049 28.6492 30.3284 29.0504 29.9639C29.4517 29.5995 29.772 29.1553 29.9907 28.66C30.2094 28.1647 30.3216 27.6292 30.3203 27.0879V22.9965C30.3672 21.0559 28.9279 19.3656 26.973 19.0936C25.7331 18.9302 24.5241 18.6308 23.361 18.1988L23.1226 18.1188C22.4528 17.9173 21.741 17.8994 21.0619 18.0669C20.3828 18.2344 19.7614 18.5812 19.2631 19.0708L18.1469 20.1805L18.0186 20.1016C15.4421 18.4722 13.2569 16.2969 11.6185 13.7302L11.5394 13.6045L12.6476 12.5016C13.172 11.9755 13.5339 11.3102 13.6901 10.5849C13.8464 9.85954 13.7904 9.10472 13.5288 8.41021C13.0949 7.25317 12.7939 6.05084 12.6315 4.82621ZM8.74984 3.48449H4.63517C4.3729 3.48486 4.11371 3.53963 3.87413 3.64516C3.63431 3.75078 3.41957 3.90487 3.24339 4.0973C3.06721 4.28971 2.93343 4.51626 2.85023 4.76241C2.76848 5.00428 2.73726 5.26007 2.75834 5.51414C3.19641 9.59953 4.59404 13.5248 6.83829 16.9715L6.84779 16.9861C8.88489 20.1749 11.6007 22.8782 14.8031 24.904L14.818 24.9135C18.2633 27.1357 22.1823 28.5239 26.2619 28.9666C26.5216 28.9901 26.7835 28.9599 27.0308 28.8778C27.2813 28.7946 27.5112 28.6602 27.7058 28.4834C27.9004 28.3067 28.0554 28.0916 28.1611 27.8522C28.2668 27.6128 28.3209 27.3542 28.3203 27.093L28.3203 27.0879L28.3203 22.9723L28.3208 22.9481C28.3429 22.0387 27.6613 21.2116 26.7031 21.0754C25.3297 20.8937 23.988 20.5625 22.6953 20.085L22.5215 20.0267C22.2021 19.9353 21.8639 19.929 21.5409 20.0087C21.2111 20.09 20.9098 20.2579 20.6682 20.4941L18.4409 22.7085L16.9606 21.7989L16.9496 21.792C14.1252 20.0058 11.7293 17.6209 9.93271 14.8063L9.92551 14.7951L8.99483 13.3153L11.2311 11.0896L11.2334 11.0873C11.4861 10.833 11.6599 10.5124 11.735 10.1638C11.8103 9.81409 11.7833 9.45018 11.6571 9.11513L11.6561 9.11241C11.1702 7.81651 10.8327 6.46993 10.6501 5.09832C10.5856 4.64982 10.3603 4.23859 10.0142 3.94136C9.66635 3.6427 9.2205 3.47982 8.75977 3.4844L8.74984 3.48449Z",
                        fill: "url(#paint1_linear_2847_1004)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.0833 6.66659C17.0833 6.1143 17.531 5.66659 18.0833 5.66659C23.0539 5.66659 27.0833 9.69602 27.0833 14.6666C27.0833 15.2189 26.6356 15.6666 26.0833 15.6666C25.531 15.6666 25.0833 15.2189 25.0833 14.6666C25.0833 10.8006 21.9493 7.66659 18.0833 7.66659C17.531 7.66659 17.0833 7.21887 17.0833 6.66659Z",
                        fill: "url(#paint2_linear_2847_1004)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2847_1004",
                        x1: "0.751953",
                        y1: "0.333252",
                        x2: "31.3765",
                        y2: "31.9809",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2847_1004",
                        x1: "0.751953",
                        y1: "0.333252",
                        x2: "31.3765",
                        y2: "31.9809",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_2847_1004",
                        x1: "0.751953",
                        y1: "0.333252",
                        x2: "31.3765",
                        y2: "31.9809",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2847_1004",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(0.75)"
                        })
                    })
                ]
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/assets/store.tsx

const Store = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "store-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2505_1238)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.04 13.1067H20.9734V14.3867C20.9734 16.5067 18.7467 18.2267 16.0134 18.2267C13.2667 18.2267 11.0534 16.5067 11.0534 14.3867V13.1067H11.04Z",
                        stroke: "url(#paint0_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M30.8933 13.1067V14.3867C30.8933 16.5067 28.6667 18.2267 25.9333 18.2267C23.1867 18.2267 20.9733 16.5067 20.9733 14.3867V13.1067",
                        stroke: "url(#paint1_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.04 13.1067V14.3867C11.04 16.5067 8.81333 18.2267 6.07999 18.2267C3.33333 18.2267 1.12 16.5067 1.12 14.3867V13.1067",
                        stroke: "url(#paint2_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.96002 7.23999H28.0534L30.9067 13.1067H1.10669L3.96002 7.23999Z",
                        stroke: "url(#paint3_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.1067 7.23999L20.96 13.1067",
                        stroke: "url(#paint4_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.8934 7.23999L11.04 13.1067",
                        stroke: "url(#paint5_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.96002 7.23994V1.2666H28.04V7.23994",
                        stroke: "url(#paint6_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.0933 30.6133V25.0666C12.0933 24.1866 12.72 23.48 13.5067 23.48H18.4933C19.28 23.48 19.9067 24.1866 19.9067 25.0666V30.6133",
                        stroke: "url(#paint7_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.04 18.2266V30.6666H3.96002V18.2266",
                        stroke: "url(#paint8_linear_2505_1238)",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2505_1238",
                        x1: "11.04",
                        y1: "13.1067",
                        x2: "15.2102",
                        y2: "21.1972",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2505_1238",
                        x1: "20.9733",
                        y1: "13.1067",
                        x2: "25.1467",
                        y2: "21.1927",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_2505_1238",
                        x1: "1.12",
                        y1: "13.1067",
                        x2: "5.29341",
                        y2: "21.1927",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_2505_1238",
                        x1: "1.10669",
                        y1: "7.23999",
                        x2: "3.33042",
                        y2: "18.5355",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_2505_1238",
                        x1: "20.1067",
                        y1: "7.23999",
                        x2: "21.778",
                        y2: "7.48309",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_2505_1238",
                        x1: "11.04",
                        y1: "7.23999",
                        x2: "12.7113",
                        y2: "7.48309",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_2505_1238",
                        x1: "3.96002",
                        y1: "1.2666",
                        x2: "6.75175",
                        y2: "12.5207",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_2505_1238",
                        x1: "12.0933",
                        y1: "23.48",
                        x2: "19.1972",
                        y2: "31.261",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_2505_1238",
                        x1: "3.96002",
                        y1: "18.2266",
                        x2: "14.1056",
                        y2: "37.8652",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2505_1238",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/assets/home-delivery.tsx

const HomeDelivery = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "home-delivery-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2847_1753)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M31.998 10.5197L17.4424 0.122803L1.53718 10.4958C1.07458 10.7975 0.944143 11.4171 1.24584 11.8797C1.54753 12.3423 2.16712 12.4727 2.62972 12.171L17.3911 2.54399L27.0833 9.46698V30.0001H4.75C4.19772 30.0001 3.75 30.4478 3.75 31.0001C3.75 31.5524 4.19772 32.0001 4.75 32.0001H28.0833C28.6356 32.0001 29.0833 31.5524 29.0833 31.0001V10.8955L30.8355 12.1471C31.285 12.4681 31.9095 12.364 32.2305 11.9146C32.5515 11.4652 32.4474 10.8407 31.998 10.5197ZM17.7197 16.5832C16.75 15.0555 13.8409 12.0001 9.96212 12.0001C6.08333 12.0001 3.49748 14.1143 2.68939 15.642C2.55859 16.4369 2.15999 17.2357 1.76019 18.0369C1.30331 18.9525 0.844859 19.8712 0.782643 20.7908C0.75 21.2733 0.75 21.795 0.75 22.3121C0.75 23.5883 1.21995 24.3833 1.66911 24.813C1.96105 25.0923 2.36029 25.1665 2.75506 25.1756C3.30391 26.8211 4.7858 28.0001 6.52778 28.0001C7.91653 28.0001 9.13998 27.2507 9.85714 26.1131C9.94155 25.9792 10.019 25.8399 10.0888 25.6958C10.1697 25.5288 10.2404 25.3555 10.3002 25.1766H11.6443C11.704 25.3555 11.7747 25.5288 11.8557 25.6958C11.9255 25.8399 12.0029 25.9792 12.0873 26.1131C12.8045 27.2507 14.0279 28.0001 15.4167 28.0001C17.1583 28.0001 18.6399 26.8215 19.1891 25.1766H19.2191C19.8256 25.1766 20.4408 25.0298 20.8765 24.5831C21.4697 23.9752 22.0833 23.0022 22.0833 21.7392C22.0833 19.4477 22.0833 17.6471 17.7197 16.5832ZM4.57993 16.3765C4.35457 17.3206 3.91833 18.1928 3.59942 18.8305L3.54975 18.9299C3.04561 19.9402 2.80805 20.4829 2.77808 20.9258C2.75084 21.3285 2.75 21.78 2.75 22.3121C2.75 22.7465 2.83747 23.0188 2.91921 23.1788L4.20721 23.2083L4.6523 24.5427C4.95704 25.4564 5.7325 26.0001 6.52778 26.0001C7.3229 26.0001 8.0982 25.4566 8.40308 24.5433L8.85931 23.1766H13.0851L13.5414 24.5433C13.8462 25.4566 14.6215 26.0001 15.4167 26.0001C16.2118 26.0001 16.9871 25.4566 17.292 24.5433L17.7482 23.1766H19.2191C19.3545 23.1766 19.4388 23.161 19.4806 23.1492C19.8185 22.7891 20.0833 22.3043 20.0833 21.7392C20.0833 20.4605 20.0289 20.059 19.8436 19.7636C19.7103 19.551 19.24 19.0125 17.2459 18.5263L16.463 18.3354L16.0311 17.655C15.6771 17.0972 14.8821 16.1431 13.7674 15.3448C12.6621 14.5533 11.3649 14.0001 9.96212 14.0001C7.01828 14.0001 5.18675 15.492 4.57993 16.3765Z",
                    fill: "url(#paint0_linear_2847_1753)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2847_1753",
                        x1: "0.75",
                        y1: "0.122803",
                        x2: "32.6266",
                        y2: "31.789",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2847_1753",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(0.75)"
                        })
                    })
                ]
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/icon-card/icon-card.tsx






const IconCard = ({ icon ="search" , title , body  })=>{
    const validIcons = [
        "search",
        "phone",
        "store",
        "home-delivery"
    ];
    const isFallbackIcon = !validIcons.includes(icon);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (icon_card_module_default()).iconCardWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (icon_card_module_default()).iconCard,
                children: [
                    icon === "search" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {}),
                    icon === "phone" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone, {}),
                    icon === "store" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Store, {}),
                    icon === "home-delivery" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDelivery, {}),
                    isFallbackIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (icon_card_module_default()).iconCardHeading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (icon_card_module_default()).iconCardBody,
                children: body
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/icon-card/index.ts


// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/utils/capitalise-first-letter/capitalise-first-letter.ts
const capitaliseFirstLetter = (string)=>string.replace(/(^|\s|-)([a-z])/g, (_, leadingWhitespaceOrHyphen, lowercaseLetter)=>leadingWhitespaceOrHyphen + lowercaseLetter.toUpperCase());

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/cta-button/cta-button.tsx




const StoreCtaButton = ({ slug , trackEventTitle  })=>{
    const StoreName = `Search all cars at ${capitaliseFirstLetter(slug)}`;
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const storeBySlugPath = `/used-cars?store=${slug}`;
    const handleClick = ()=>{
        trackEvent({
            eventName: trackEventTitle,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                action: "select",
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    type: capitaliseFirstLetter(slug),
                    category: trackEventTitle,
                    label: "search all cars"
                }
            }
        });
        window.open(storeBySlugPath, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
        type: "submit",
        "data-testid": "store-button",
        onClick: handleClick,
        children: StoreName
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/cta-button/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/how-it-works/how-it-works.tsx





function HowItWorks({ title , howCinchWorksList , slug  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (how_it_works_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                className: (how_it_works_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (how_it_works_module_default()).cardList,
                children: howCinchWorksList.map((listItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(IconCard, {
                        icon: listItem.icon,
                        title: listItem.title,
                        body: listItem.body
                    }, listItem.title))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCtaButton, {
                slug: slug,
                trackEventTitle: "how it works"
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/how-it-works/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-intro/store-intro.module.css
var store_intro_module = __webpack_require__(11710);
var store_intro_module_default = /*#__PURE__*/__webpack_require__.n(store_intro_module);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/landing-feature-store-page.module.css
var landing_feature_store_page_module = __webpack_require__(14775);
var landing_feature_store_page_module_default = /*#__PURE__*/__webpack_require__.n(landing_feature_store_page_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-intro/store-intro.tsx




const StoreIntro = ({ introText , title , slug  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (store_intro_module_default()).introSectionWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (landing_feature_store_page_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (store_intro_module_default()).storeIntroText,
                children: introText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (store_intro_module_default()).introButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCtaButton, {
                    slug: slug,
                    trackEventTitle: "Intro section"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-intro/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/index.ts



// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-details-wrapper/store-details-wrapper.module.css
var store_details_wrapper_module = __webpack_require__(86875);
var store_details_wrapper_module_default = /*#__PURE__*/__webpack_require__.n(store_details_wrapper_module);
// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(82070);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-map/index.ts

/* harmony default export */ var store_map = (dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1741), __webpack_require__.e(767)]).then(__webpack_require__.bind(__webpack_require__, 90767)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90767)
            ]
    },
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90767)
            ]
    },
    ssr: false
}));

// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-details-list/store-details-list.module.css
var store_details_list_module = __webpack_require__(57117);
var store_details_list_module_default = /*#__PURE__*/__webpack_require__.n(store_details_list_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-details-list/store-details-list.tsx



const StoreDetailsList = ({ icon , title , children  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (store_details_list_module_default()).storeDetailsSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                name: icon,
                size: 20,
                className: (store_details_list_module_default()).svg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (store_details_list_module_default()).storeDetails,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (store_details_list_module_default()).storeDetailsTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (store_details_list_module_default()).storeDetailsContent,
                        children: children
                    })
                ]
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/utils/capitalise-first-letter/add-brackets/add-brackets.ts
const addBrackets = (string)=>{
    if (string.startsWith("(") && string.endsWith(")")) {
        return string;
    }
    return `(${string})`;
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-details-wrapper/store-details-wrapper.tsx







const StoreDetailsWrapper = ({ slug , latitude , longitude , address , phoneNumbers , openingHours  })=>{
    const { addressLine1 , addressLine2 , townOrCity , postCode  } = address;
    const storeAddress = [
        addressLine1,
        addressLine2,
        townOrCity,
        postCode
    ];
    const storeType = (0,shared_src/* generateStoreType */.or)(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                id: "store-details",
                className: (store_details_wrapper_module_default()).heading,
                children: `${slug} ${storeType} details`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (store_details_wrapper_module_default()).storeWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (store_details_wrapper_module_default()).storeDetailsSectionWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetailsList, {
                                icon: "location",
                                title: "Where to find us",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (store_details_wrapper_module_default()).storeAddress,
                                    children: storeAddress.map((item)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: item === null || item === void 0 ? void 0 : item.toString()
                                        }, item === null || item === void 0 ? void 0 : item.toString());
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetailsList, {
                                icon: "phone",
                                title: "Get in touch",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: phoneNumbers.map((item, index)=>{
                                        const hasPurpose = item.purpose.length > 0;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                item.phoneNumber,
                                                hasPurpose && ` ${addBrackets(item.purpose)}`
                                            ]
                                        }, index);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetailsList, {
                                icon: "time",
                                title: "Opening Hours",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: openingHours.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: (store_details_wrapper_module_default()).openingTimes,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (store_details_wrapper_module_default()).daysOfWeek,
                                                    children: item.daysOfWeek
                                                }),
                                                item.openingTime === "Closed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.openingTime
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        item.openingTime,
                                                        " - ",
                                                        item.closingTime
                                                    ]
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (store_details_wrapper_module_default()).map,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(store_map, {
                            coordinates: [
                                latitude,
                                longitude
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-details-wrapper/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-faqs/store-faqs.module.css
var store_faqs_module = __webpack_require__(96949);
var store_faqs_module_default = /*#__PURE__*/__webpack_require__.n(store_faqs_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-faqs/store-faqs.tsx






const StoreFaqs = ({ title , faqs  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const accordionItems = faqs.map((faq)=>({
            title: faq.title,
            children: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,shared_src/* renderWithResolver */.be)(faq.body, {
                        link: {
                            openNewTab: true,
                            adobeTracking: {
                                eventName: "FAQ link",
                                type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                                data: {
                                    action: "click",
                                    event: {
                                        name: analytics_src/* EventNames.click */.Vy.click,
                                        category: "FAQ link",
                                        label: `${faq.title} link clicked`
                                    }
                                }
                            }
                        }
                    })
                })
        }));
    const FaqCategory = "FAQ accordion";
    const handleItemClick = (isOpen, title)=>{
        trackEvent({
            eventName: FaqCategory,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                action: `${title} - ${isOpen ? "open" : "close"}`,
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: FaqCategory,
                    label: "cinch store"
                }
            }
        });
    };
    const handleCtaClick = ()=>{
        trackEvent({
            eventName: FaqCategory,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                action: "View all FAQs",
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: FaqCategory,
                    label: "cinch store"
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                id: "faq-section",
                className: (store_faqs_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Accordion */.UQ, {
                title: title,
                items: accordionItems,
                buttonId: title,
                sectionId: "store-faq-section",
                onItemToggle: (itemIndex, isOpen)=>handleItemClick(isOpen, title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (store_faqs_module_default()).cantFindWhatYoureLookingFor,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Can’t find what you’re looking for?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                        classNames: {
                            button: (store_faqs_module_default()).button
                        },
                        element: "a",
                        href: "/support",
                        onClick: ()=>handleCtaClick(),
                        children: "View all FAQs"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/store-faqs/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/data/landing-store-feature.data.ts

function landing_store_feature_data_storeStaticPaths({ links  }) {
    const paths = [];
    for (const linkKey of Object.keys(links)){
        if (links[linkKey].is_folder) {
            continue;
        }
        const slug = links[linkKey].slug.split("/")[1];
        paths.push({
            params: {
                slug
            }
        });
    }
    return paths;
}
const generateFallbackTitle = (storeName)=>{
    const cinchStoreText = (0,shared_src/* generateStoreNameWithType */.pW)(storeName);
    return `${cinchStoreText} | Buy used cars in ${storeName}`;
};
const generateFallbackDescription = (storeName)=>{
    const storeType = storeName === "Corby" ? "warehouse" : "store";
    return `Welcome to the cinch ${storeType} in ${storeName}, offering used cars, part exchange & car viewing. Visit the cinch ${storeType} ${storeName} for faff-free car buying.`;
};

// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/vehicles-in-stock/carousel/carousel.module.css
var carousel_module = __webpack_require__(96732);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/vehicles-in-stock/carousel/carousel.tsx






const Carousel = ({ carouselName , vehicles  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    if (!vehicles) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (carousel_module_default()).carouselLoading,
            children: "Loading..."
        });
    }
    const vehiclesInStock = vehicles.slice(0, 6);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                name: carouselName,
                swiperSettings: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        564: {
                            slidesPerView: 1
                        },
                        768: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    }
                },
                ariaLabel: `${carouselName}-carousel`,
                children: vehiclesInStock.map((vehicle)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* VehicleCard */.Ur, {
                            vehicle: vehicle,
                            id: "vehicles-in-stock-carousel",
                            isSaved: false,
                            isPending: false,
                            isAvailable: vehicle.isAvailable,
                            onCardClick: ()=>{
                                trackEvent({
                                    eventName: `Cars in stock at cinch store`,
                                    type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                                    data: {
                                        event: {
                                            name: analytics_src/* EventNames.click */.Vy.click,
                                            category: "Cars in stock at cinch store",
                                            type: vehicle.site,
                                            label: "pdp card",
                                            action: vehicle.vehicleId
                                        }
                                    }
                                });
                            }
                        })
                    }, vehicle.vehicleId))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* CarouselControls */.J8, {
                customClassNames: (carousel_module_default()).controlsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselPagination */.Jj, {
                        name: carouselName,
                        className: classnames_default()(`${carouselName}-pagination`, (carousel_module_default()).pagination, (carousel_module_default()).customPagination),
                        "data-testid": "ds-carousel-pagination",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselNavigation */.Pn, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        ariaHidden: true,
                        customClassNames: {
                            prevButton: (carousel_module_default()).prevButton,
                            nextButton: (carousel_module_default()).nextButton
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/vehicles-in-stock/vehicles-in-stock.module.css
var vehicles_in_stock_module = __webpack_require__(98492);
var vehicles_in_stock_module_default = /*#__PURE__*/__webpack_require__.n(vehicles_in_stock_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/vehicles-in-stock/vehicles-in-stock.tsx






const VehiclesInStock = ({ slug , vehicles  })=>{
    const storeNameWithType = (0,shared_src/* generateStoreNameWithType */.pW)(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (vehicles_in_stock_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (landing_feature_store_page_module_default()).heading,
                children: `Cars in stock at ${storeNameWithType}`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                carouselName: "vehicles-in-stock-carousel",
                vehicles: vehicles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (vehicles_in_stock_module_default()).buttonWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCtaButton, {
                    slug: slug,
                    trackEventTitle: "cars in stock at cinch store"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/json-ld-script/helpers/structured-data.ts
var structured_data = __webpack_require__(82749);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/why-cinch/why-cinch.module.css
var why_cinch_module = __webpack_require__(75882);
var why_cinch_module_default = /*#__PURE__*/__webpack_require__.n(why_cinch_module);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-page/src/lib/components/why-cinch/why-cinch-carousel/why-cinch-carousel.module.css
var why_cinch_carousel_module = __webpack_require__(35714);
var why_cinch_carousel_module_default = /*#__PURE__*/__webpack_require__.n(why_cinch_carousel_module);
// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/why-cinch/why-cinch-carousel/why-cinch-carousel.tsx






function chunkArray(arr, size) {
    return Array.from({
        length: Math.ceil(arr.length / size)
    }, (v, i)=>arr.slice(i * size, i * size + size));
}
const WhyCinchCarousel = ({ content , carouselName  })=>{
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    const groupSize = 2;
    let groupedCards = [];
    try {
        groupedCards = chunkArray(content, groupSize);
    } catch (error) {
        if (error instanceof Error || typeof error === "string") {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        groupedCards = [];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                name: carouselName,
                swiperSettings: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        564: {
                            slidesPerView: 1
                        }
                    }
                },
                ariaLabel: `${carouselName}-carousel`,
                children: groupedCards.map((group, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (why_cinch_carousel_module_default()).groupedCardWrapper,
                            children: group.map((content)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WhyBuyContentCard, {
                                    content: content
                                }, `${content.title}`))
                        })
                    }, `group-${index}`))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* CarouselControls */.J8, {
                customClassNames: (why_cinch_carousel_module_default()).controlsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselPagination */.Jj, {
                        name: carouselName,
                        customClassNames: classnames_default()(`${carouselName}-pagination`, (why_cinch_carousel_module_default()).pagination, (why_cinch_carousel_module_default()).customPagination),
                        "data-testid": "ds-carousel-pagination",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselNavigation */.Pn, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        ariaHidden: true,
                        customClassNames: {
                            prevButton: (why_cinch_carousel_module_default()).prevButton,
                            nextButton: (why_cinch_carousel_module_default()).nextButton
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/why-cinch/why-cinch-carousel/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/why-cinch/why-cinch.tsx





const WhyBuyContentCard = ({ content  })=>{
    const { title , text  } = content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (why_cinch_module_default()).contentCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                className: (why_cinch_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (why_cinch_module_default()).paragraph,
                children: text
            })
        ]
    });
};
const WhyCinch = ({ whyBuyContent  })=>{
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 768;
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (why_cinch_module_default()).carouselWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyCinchCarousel, {
            content: whyBuyContent,
            carouselName: "why-buy-carousel"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (why_cinch_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (why_cinch_module_default()).contentContainer,
            children: whyBuyContent.map((content)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WhyBuyContentCard, {
                    content: content
                }, `content-${content.title}`))
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/components/why-cinch/index.ts


// EXTERNAL MODULE: ../../../libs/data/trustpilot/src/index.ts + 6 modules
var trustpilot_src = __webpack_require__(99649);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/landing-feature-store-page.tsx

















function LandingFeatureStorePage({ story , generatedAt , preview , storeVehicles  }) {
    var ref, ref1, ref2;
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    const shouldShowCarousel = (isMobile || storeVehicles.length > 2) && storeVehicles.length > 0;
    const starRating = (0,trustpilot_src/* useTrustpilotScore */.b6)();
    const shouldShowTrustPilotScoreless = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ShowScorelessTrustpilot */.X.ShowScorelessTrustpilot) === "true";
    const shouldShowTruspilotScoreless = starRating ? shouldShowTrustPilotScoreless || starRating <= 4.2 : shouldShowTrustPilotScoreless;
    const numberOfReviews = (0,trustpilot_src/* useTrustpilotReviewCount */.Ji)();
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const { storeIntro , storeHowCinchWorksComponent , storeFAQSection , mapInformation , address , phoneNumbers , openingHoursList , storeHero , storeWhyBuy  } = content;
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    const storeIntroTitle = storeIntro[0].title;
    const storeIntroText = (0,shared_src/* renderWithResolver */.be)(storeIntro[0].body);
    const howItWorksTitle = storeHowCinchWorksComponent[0].title;
    const howCinchWorksList = storeHowCinchWorksComponent[0].howCinchWorksList;
    const { titleAndText: whyBuyContent  } = storeWhyBuy[0];
    const storeSlug = story.slug;
    const storeName = capitaliseFirstLetter(storeSlug);
    const [storeAddress] = address;
    const storeImageUrl = storeHero[0].image.filename;
    const { title: faqTitle , faqs  } = storeFAQSection[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* JsonLdScript */.HT, {
                schema: (0,structured_data/* formatStoreToSchema */.RQ)({
                    storeSlug,
                    storeAddress,
                    mapInformation,
                    phoneNumbers,
                    openingHoursList,
                    storeImageUrl
                }),
                tagId: "automotive business"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: generateFallbackTitle(storeName),
                fallbackDescription: generateFallbackDescription(storeName)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (landing_feature_store_page_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_store_page_module_default()).storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreIntro, {
                            title: storeIntroTitle,
                            introText: storeIntroText,
                            slug: storeSlug
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        backgroundColor: "#f2f5ff",
                        className: {
                            container: (landing_feature_store_page_module_default()).howItWorksWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks, {
                            title: howItWorksTitle,
                            howCinchWorksList: howCinchWorksList,
                            slug: storeSlug
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        backgroundColor: "#F9F9F9",
                        className: {
                            inner: (landing_feature_store_page_module_default()).trustpilotWrapper
                        },
                        children: shouldShowTruspilotScoreless ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* TrustpilotScoreless */.jP, {
                            numberOfReviews: numberOfReviews
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* TrustpilotWidget */.cE, {
                            height: "24px",
                            widget: isMobile ? ui_src/* TrustpilotWidgetTemplates.microStar */.sd.microStar : ui_src/* TrustpilotWidgetTemplates.microCombo */.sd.microCombo
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_store_page_module_default()).storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetailsWrapper, {
                            slug: storeName,
                            latitude: Number.parseFloat((ref1 = mapInformation[0]) === null || ref1 === void 0 ? void 0 : ref1.latitude),
                            longitude: Number.parseFloat((ref2 = mapInformation[0]) === null || ref2 === void 0 ? void 0 : ref2.longitude),
                            address: storeAddress,
                            phoneNumbers: phoneNumbers,
                            openingHours: openingHoursList
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_store_page_module_default()).storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreFaqs, {
                            title: faqTitle,
                            faqs: faqs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        backgroundColor: "#f8f6ff",
                        className: {
                            container: classnames_default()((landing_feature_store_page_module_default()).storeWrapper, (landing_feature_store_page_module_default()).whyCinchWrapper),
                            inner: (landing_feature_store_page_module_default()).storeWrapperInner
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyCinch, {
                            whyBuyContent: whyBuyContent
                        })
                    }),
                    shouldShowCarousel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_store_page_module_default()).storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehiclesInStock, {
                            slug: storeSlug,
                            vehicles: storeVehicles
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var landing_feature_store_page = ((/* unused pure expression or super */ null && (LandingFeatureStorePage)));

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/get-static-path.ts


const getStaticPathsGenerator = (slug)=>async ()=>{
        // Get the paths we want to pre-render based on data
        try {
            const links = await getLinks(slug);
            const paths = storeStaticPaths({
                links
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/lib/get-static-props.ts




const VEHICLE_SEARCH_URL = `${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.SearchServiceUrl */.X.SearchServiceUrl)}/vehicles`;
const formatHeroAddress = (address)=>`${address.addressLine1}, ${address.addressLine2}, ${address.townOrCity}, ${address.postCode}`;
const getStaticPropsfn = async ({ params , preview =false  })=>{
    const storeName = params === null || params === void 0 ? void 0 : params.slug;
    try {
        const story = await (0,src/* getStoryBySlug */.OI)(`store/${storeName}`, {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Store information story not found");
        }
        let storeVehicles = [];
        try {
            const response = await fetch(`${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.SearchServiceUrl */.X.SearchServiceUrl)}/vehicles?store=${storeName}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch vehicles: ${response.statusText}`);
            }
            const { vehicleListings  } = await response.json();
            storeVehicles = vehicleListings.length < 9 ? vehicleListings : vehicleListings.slice(0, 9);
        } catch (error) {
            if (error instanceof Error || typeof error === "string") {
                (0,datadog_server_src/* tagError */.$k)(error);
            }
            storeVehicles = [];
        }
        (0,datadog_server_src/* setTag */.YA)("response.code", 200);
        (0,datadog_server_src/* setTag */.YA)("page.rendered", "ISR");
        (0,datadog_server_src/* setTag */.YA)("page.revalidate-in", "60s");
        (0,datadog_server_src/* setTag */.YA)("page.name", `store/${storeName}`);
        (0,datadog_server_src/* setTag */.YA)("page.params", JSON.stringify({
            preview,
            storeVehicles
        }, null, 2));
        (0,datadog_server_src/* setTag */.YA)("page.response-code", "200");
        const title = (0,shared_src/* generateStoreNameWithType */.pW)(storeName, true);
        const heroProps = {
            ...story.content.storeHero[0],
            title,
            address: formatHeroAddress(story.content.address[0]),
            telephoneNumber: story.content.phoneNumbers[0].phoneNumber
        };
        return {
            props: {
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    showBorderRadius: true,
                    heroProps
                },
                storeVehicles
            },
            revalidate: 60
        };
    } catch (error1) {
        if (typeof error1 === "string" || error1 instanceof Error) {
            console.log(error1);
        }
        return {
            notFound: true
        };
    }
};
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("store-page.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-page/src/index.ts




;// CONCATENATED MODULE: ./pages/store/[slug].tsx
var __N_SSG = true;



/***/ }),

/***/ 17682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"how-it-works_root__Feh2X","title":"how-it-works_title__eR8hL","cardList":"how-it-works_cardList__7K4om"};

/***/ }),

/***/ 65432:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iconCardWrapper":"icon-card_iconCardWrapper__KPak_","iconCard":"icon-card_iconCard__XthRT","iconCardHeading":"icon-card_iconCardHeading__sguUG","iconCardBody":"icon-card_iconCardBody__Idwto"};

/***/ }),

/***/ 57117:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storeDetailsSection":"store-details-list_storeDetailsSection__ErBvB","storeDetails":"store-details-list_storeDetails__agXH6","storeDetailsTitle":"store-details-list_storeDetailsTitle___m_I2","storeDetailsContent":"store-details-list_storeDetailsContent__yHCxX","svg":"store-details-list_svg__hgYdN"};

/***/ }),

/***/ 86875:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storeWrapper":"store-details-wrapper_storeWrapper__8D99h","storeDetailsSectionWrapper":"store-details-wrapper_storeDetailsSectionWrapper____7Ye","heading":"store-details-wrapper_heading__KHjqc","map":"store-details-wrapper_map__qmIMg","openingTimes":"store-details-wrapper_openingTimes__0d32j","daysOfWeek":"store-details-wrapper_daysOfWeek__kC5r3","storeAddress":"store-details-wrapper_storeAddress__RQy_t"};

/***/ }),

/***/ 96949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"store-faqs_heading__wBS1r","cantFindWhatYoureLookingFor":"store-faqs_cantFindWhatYoureLookingFor__6L9c3","button":"store-faqs_button__QEXbv"};

/***/ }),

/***/ 11710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storeIntroText":"store-intro_storeIntroText__hJsES","introSectionWrapper":"store-intro_introSectionWrapper__btKTc","introButton":"store-intro_introButton__w_eQp"};

/***/ }),

/***/ 96732:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__j5qQs","pagination":"carousel_pagination__PMl8f","customPagination":"carousel_customPagination__wu4W_"};

/***/ }),

/***/ 98492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"vehicles-in-stock_root__Gml2_","buttonWrapper":"vehicles-in-stock_buttonWrapper__l2oEd","title":"vehicles-in-stock_title__WJ1_J","carouselLoading":"vehicles-in-stock_carouselLoading__x1yK0"};

/***/ }),

/***/ 35714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"why-cinch-carousel_controlsWrapper__65z7c","pagination":"why-cinch-carousel_pagination__Tquv6","customPagination":"why-cinch-carousel_customPagination__ZFETa","groupedCardWrapper":"why-cinch-carousel_groupedCardWrapper__ipoc4"};

/***/ }),

/***/ 75882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"why-cinch_root__GcCnn","contentContainer":"why-cinch_contentContainer__InepG","imageContainer":"why-cinch_imageContainer__lvHHm","contentCard":"why-cinch_contentCard__pkRDy","heading":"why-cinch_heading__aNFpH","paragraph":"why-cinch_paragraph__S6Dp5","carouselWrapper":"why-cinch_carouselWrapper__AS_sw"};

/***/ }),

/***/ 14775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"landing-feature-store-page_root__0JAkZ","storeWrapper":"landing-feature-store-page_storeWrapper__eRb_0","whyCinchWrapper":"landing-feature-store-page_whyCinchWrapper__2Nnts","storeWrapperInner":"landing-feature-store-page_storeWrapperInner__uceyW","heading":"landing-feature-store-page_heading__FpHBD","howItWorksWrapper":"landing-feature-store-page_howItWorksWrapper__SBEmH","trustpilotWrapper":"landing-feature-store-page_trustpilotWrapper__QbDQ_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(89787); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);